export var FontWeightProp;
(function (FontWeightProp) {
    FontWeightProp[FontWeightProp["normal"] = 400] = "normal";
    FontWeightProp[FontWeightProp["intermediary"] = 500] = "intermediary";
    FontWeightProp[FontWeightProp["slightlyBold"] = 600] = "slightlyBold";
    FontWeightProp[FontWeightProp["bold"] = 700] = "bold";
    FontWeightProp["inherit"] = "inherit";
})(FontWeightProp || (FontWeightProp = {}));
